import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/lib/store';

export function useSendMessageToAdmin() {
  const isAdminEmbed = useSelector(
    (state: RootState) => state.theme.isAdminEmbed,
  );
  const adminUrl = process.env.NEXT_PUBLIC_ADMIN_URL;

  const sendMessage = useCallback(
    (type: string, payload: any) => {
      if (!isAdminEmbed || !adminUrl || typeof window === 'undefined') {
        return;
      }

      try {
        const parentOrigin = new URL(adminUrl).origin;
        window.parent.postMessage(
          {
            type,
            payload,
            timestamp: new Date().toISOString(),
          },
          parentOrigin,
        );
      } catch (error) {
        console.error('Error sending message to admin:', error);
      }
    },
    [isAdminEmbed, adminUrl],
  );

  return {
    sendMessage,
    canSendMessage: isAdminEmbed && !!adminUrl,
  };
}
